import { Campaign } from '@/domain/types/campaigns';
import Button from '@/presentation/components/button';
import Spinner from '@/presentation/components/spinner';
import { Column } from '@/presentation/components/table';
import Table from '@/presentation/components/table';
import useCampaigns from '@/presentation/hooks/firebase/use-campaigns';
import { useEffect, useState } from 'react';
import { FiPlus } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { columns } from './env/columns';

const CampaignsPage = () => {
  const navigate = useNavigate();
  const { campaigns, isLoading, error, fetchCampaigns, deleteCampaign, toggleActive } =
    useCampaigns();
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetchCampaigns();
  }, [fetchCampaigns]);

  const filtered = campaigns.filter(
    (c) =>
      c.name.toLowerCase().includes(search.toLowerCase()) ||
      c.hashtag.toLowerCase().includes(search.toLowerCase()),
  );

  const handleDelete = async (campaign: Campaign) => {
    if (!window.confirm(`¿Eliminar la campaña "${campaign.name}"?`)) return;
    await deleteCampaign(campaign.id);
  };

  const handleToggle = async (campaign: Campaign) => {
    await toggleActive(campaign.id, !campaign.isActive);
  };

  const actionsColumn: Column<Campaign> = {
    header: 'Acciones',
    accessor: 'id',
    render: (_value, campaign) => (
      <div className="flex gap-2 flex-wrap">
        <button
          onClick={() => navigate(`/dashboard/campaigns/detail/${campaign.id}`)}
          className="text-blue-600 hover:underline text-sm"
        >
          Ver detalle
        </button>
        <button
          onClick={() => navigate(`/dashboard/campaigns/add?edit=${campaign.id}`)}
          className="text-amber-600 hover:underline text-sm"
        >
          Editar
        </button>
        <button
          onClick={() => handleToggle(campaign)}
          className={`text-sm hover:underline ${campaign.isActive ? 'text-orange-600' : 'text-green-600'}`}
        >
          {campaign.isActive ? 'Desactivar' : 'Activar'}
        </button>
        <button
          onClick={() => handleDelete(campaign)}
          className="text-red-600 hover:underline text-sm"
        >
          Eliminar
        </button>
      </div>
    ),
  };

  if (error) return <p className="text-red-500 p-4">{error}</p>;

  return (
    <div className="flex flex-col gap-4 p-4">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Campañas</h1>
          <p className="text-sm text-gray-600 mt-1">
            Gestiona las campañas de hashtags y consulta sus rankings
          </p>
        </div>
        <Button
          label="Nueva campaña"
          icon={<FiPlus />}
          onClick={() => navigate('/dashboard/campaigns/add')}
        />
      </div>

      <input
        type="text"
        placeholder="Buscar por nombre o hashtag..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="border rounded-lg px-4 py-2 w-full max-w-sm"
      />

      {isLoading ? (
        <div className="flex justify-center py-8">
          <Spinner />
        </div>
      ) : (
        <Table columns={[...columns, actionsColumn]} data={filtered} />
      )}
    </div>
  );
};

export default CampaignsPage;
